import React, { useMemo, useState } from 'react'
import { useLocalStorage, useNewTranslation } from 'hooks'
import OldIcon from 'components/Icon/Icon'
import styled from 'particles/themes/styled'
import i18nOld from 'config/i18nOld'
import i18n, { I18N_LOCAL_STORAGE_KEY } from 'config/i18n'
import { theme } from 'theme'
import Text from 'particles/Text'
import { api } from 'services/api'
import { NavIconButton } from './styles'
import { StyledButton } from 'components/Shared/Button/NavButton'
import Menu from 'particles/Menu'
import MenuItem from 'particles/MenuItem'
import Icon from 'particles/Icon'

interface LanguageFilterProps {
    className?: string
    isExtend?: boolean
    isSignUp?: boolean
}

const LanguageFilter: React.FC<LanguageFilterProps> = ({ className, isExtend, isSignUp }) => {
    const [t] = useNewTranslation()
    const [languageCode, setLanguageCode] = useLocalStorage(I18N_LOCAL_STORAGE_KEY, i18n.language)
    const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null)
    const handleOpenMenu = (event: React.MouseEvent<HTMLDivElement>) => {
        setMenuAnchorEl(event.currentTarget)
    }
    const handleCloseMenu = () => {
        setMenuAnchorEl(null)
    }

    const handleLanguage = (code: string) => {
        setLanguageCode(code)
        i18nOld.changeLanguage(code)
        i18n.changeLanguage(code)

        api.setHeader('Accept-Language', code)
    }
    const selectButtonDisplayLanguage = (code: string) => {
        switch (code) {
            case 'en':
                return 'EN'
            case 'zh':
                return '中'
            case 'id':
                return 'ID'
            case 'vi':
                return 'VI'
            case 'th':
                return 'TH'
            default:
                return 'EN'
        }
    }
    const selectHoverDisplayLanguage = (code: string) => {
        switch (code) {
            case 'en':
                return t('language.english')
            case 'zh':
                return t('language.chineseTraditional')
            case 'id':
                return t('language.bahasaIndonesia')
            case 'vi':
                return t('language.vietnamese')
            case 'th':
                return t('language.thai')
            default:
                return t('language.english')
        }
    }
    const displayShortLanguage = useMemo(() => selectButtonDisplayLanguage(languageCode), [languageCode])
    const displayFullLanguage = useMemo(() => selectHoverDisplayLanguage(languageCode), [languageCode])

    const LANGUAGE_SETTINGS = [
        {
            text: selectHoverDisplayLanguage('en'),
            value: 'en',
            onClick: handleLanguage,
        },
        {
            text: selectHoverDisplayLanguage('zh'),
            value: 'zh',
            onClick: handleLanguage,
        },
        {
            text: selectHoverDisplayLanguage('id'),
            value: 'id',
            onClick: handleLanguage,
        },
        {
            text: selectHoverDisplayLanguage('vi'),
            value: 'vi',
            onClick: handleLanguage,
        },
        {
            text: selectHoverDisplayLanguage('th'),
            value: 'th',
            onClick: handleLanguage,
        },
    ]
    return (
        <div className={className}>
            {isExtend || isSignUp ? (
                <div className="extend-filter">
                    <div className="dropdown-control" onClick={handleOpenMenu}>
                        <div className="dropdown-control-left">
                            {isSignUp ? <Icon name="globeSimple" /> : <OldIcon.LanguageIcon width={20} height={20} />}
                            <Text>{displayFullLanguage}</Text>
                        </div>
                        <Icon name="caretDown" />
                    </div>
                </div>
            ) : (
                <NavIconButton label={displayFullLanguage ?? ''} onClick={handleOpenMenu}>
                    <StyledButton width="36px" height="36px">
                        {displayShortLanguage}
                    </StyledButton>
                </NavIconButton>
            )}
            <Menu
                size="s"
                open={Boolean(menuAnchorEl)}
                anchorEl={menuAnchorEl}
                onClose={handleCloseMenu}
                {...(isExtend || isSignUp
                    ? { PaperProps: { sx: { width: isSignUp ? '160px' : 'calc(200% - 1rem)' } } }
                    : {
                          width: 180,
                          transformOrigin: { vertical: 'center', horizontal: 'left' },
                          anchorOrigin: {
                              vertical: 'center',
                              horizontal: 'right',
                          },
                          sx: { marginLeft: '30px' },
                      })}
            >
                {LANGUAGE_SETTINGS.map((option, index) => (
                    <MenuItem.Text
                        key={`menu-item-filter-${index}`}
                        text={option.text}
                        onClick={() => {
                            handleCloseMenu()
                            option.onClick(option.value)
                        }}
                        selected={option.text === displayFullLanguage}
                    />
                ))}
            </Menu>
        </div>
    )
}

export default styled(LanguageFilter)`
    .extend-filter {
        margin-top: 20px;
    }
    .dropdown-control {
        display: flex;
        height: 36px;
        cursor: pointer;
        padding: 8px 7px 8px 4px;
        box-sizing: border-box;
        justify-content: space-between;
        align-items: center;
        background-color: transparent;
        color: ${theme.newColors.neutral700};
        font-weight: ${theme.fontWeight.medium};
        border-radius: 4px;
        border: 1px solid ${theme.newColors.neutral200};
        .dropdown-control-left {
            display: flex;
            gap: 4px;
            align-items: center;
        }
    }
`
